// Store the current route in password protected area in order to pass it to
// the auth.global.ts middleware in order to redirect the user to their last
// location after they log in with Auth0, A.K.A deep links feature

import { useRouter } from 'vue-router';
import { savePostLoginRedirect } from '~/composables/usePostLoginRedirect';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.afterEach((to: any) => {
    savePostLoginRedirect(to.fullPath, { source: 'save-lms-route' });
  });
});
